import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'big-ui-company-logo',
    templateUrl: './company-logo.component.html',
    imports: [TranslocoPipe],
})
export class CompanyLogoComponent {

}
